import { useLayoutEffect, useRef, useState } from "react";
import { AdvancedMarker, useAdvancedMarkerRef } from "@vis.gl/react-google-maps";
import { Link } from "react-router-dom";

import PropertyMarker from "./property-markers";
import PropertyDetails from "../property-details";
import PropertyMarkerMoblie from "./mobile-property-markers";

import "./styles.css";

function AdvancedMarkers({ position, property, mapWrapperRef, extractTransformValues, setSelectedProperty, params }) {
  const [markerRef, marker] = useAdvancedMarkerRef();
  const [isOpened, setIsOpened] = useState(false);
  const popoverRef = useRef();

  const navigateURL = `/property/${property?.id}/${property?.name}`;

  const MARKER_HEIGHT = 38;
  const MARKER_WIDTH = 30;
  const POPOVER_WIDTH = 360;
  const POPOVER_OFFSET = 12;

  const popoverLeft = (POPOVER_WIDTH / 2 - MARKER_WIDTH / 2) * -1;
  const popoverTop = MARKER_HEIGHT;

  useLayoutEffect(() => {
    const popoverElm = popoverRef.current;

    if (!isOpened || !popoverElm) {
      return;
    }

    const mapHeight = mapWrapperRef.current.clientHeight;
    const mapWidth = mapWrapperRef.current.clientWidth;

    const relativeXCodinate = mapWidth / 2 - MARKER_WIDTH / 2;
    const relativeYCodinate = mapHeight / 2 - MARKER_HEIGHT;

    const markerElement = marker?.targetElement;

    const { x, y } = extractTransformValues(markerElement?.style.transform);

    const popoverHeight = popoverElm?.clientHeight;

    const yDifference = Math.abs(relativeYCodinate) - Math.abs(y);
    const xDifference = Math.abs(relativeXCodinate) - Math.abs(x);

    let newXPosition = xDifference;
    let newYPosition = yDifference;

    if (Math.abs(xDifference) > Math.abs(popoverLeft)) {
      newXPosition = popoverLeft;
    } else {
      newXPosition = (newXPosition - POPOVER_OFFSET) * -1;

      if (x > 0) {
        newXPosition = (POPOVER_WIDTH - MARKER_WIDTH) * -1 - newXPosition;
      }
    }

    newYPosition = popoverTop + POPOVER_OFFSET;

    if (Math.abs(yDifference) + MARKER_HEIGHT / 2 < Math.abs(popoverHeight) && y > 0) {
      newYPosition = (popoverHeight + POPOVER_OFFSET) * -1;
    }

    popoverElm.style.top = `${newYPosition}px`;
    popoverElm.style.left = `${newXPosition}px`;

    markerElement.style.zIndex = 10;
  }, [isOpened]);

  useLayoutEffect(() => {
    const markerElement = marker?.targetElement;
    markerElement?.classList?.add("advance-marker");
    markerElement?.setAttribute("data-property-id", property.id);
  }, [marker]);

  const isDesktop = window.innerWidth > 991;

  return (
    <AdvancedMarker key={property.id} position={position} ref={markerRef} style={{ pointerEvents: "auto", cursor: "pointer" }} className="advance-marker ">
      {isDesktop && isOpened && (
        <div
          ref={popoverRef}
          style={{
            position: "absolute",
            width: `${POPOVER_WIDTH}px`,
            height: "fit-content",
            top: `${popoverTop}px`,
            left: `${popoverLeft}px`,
          }}
        >
          <PropertyDetails property={property} params={params} isActivateByHover={false} />
        </div>
      )}

      {isDesktop ? (
        <Link
          to={navigateURL}
          target="_blank"
          className="map-marker"
          data-property-id={property.id}
          onMouseOver={() => {
            setIsOpened(true);
          }}
          onMouseLeave={() => {
            setIsOpened(false);
            if (marker) {
              marker.targetElement.style.zIndex = "auto";
            }
          }}
        >
          <PropertyMarker className="marker-img" property={property} params={params} />
        </Link>
      ) : (
        <button
          className={"map-marker-mobile"}
          data-property-id={property.id}
          onClick={(e) => {
            e.currentTarget.classList.add("active");
            e.currentTarget.classList.remove("visited-marker");

            setSelectedProperty((prev) => {
              if (prev?.id === property.id) {
                return null;
              }

              if (prev?.id) {
                const oldMarkerElement = document.querySelector(`.map-marker-mobile[data-property-id='${prev.id}']`);

                oldMarkerElement.classList.add("visited-marker");
                oldMarkerElement.classList.remove("active");
              }

              return property;
            });
          }}
        >
          <PropertyMarkerMoblie property={property} />
        </button>
      )}
    </AdvancedMarker>
  );
}
export default AdvancedMarkers;
